(function($) {
    "use strict"; // Start of use strict

    // Smooth scrolling using jQuery easing
    $('a.js-scroll-trigger[href*="#"]:not([href="#"])').click(function() {
        if (location.pathname.replace(/^\//, '') == this.pathname.replace(/^\//, '') && location.hostname == this.hostname) {
            var target = $(this.hash);
            target = target.length ? target : $('[name=' + this.hash.slice(1) + ']');
            if (target.length) {
                $('html, body').animate({
                    scrollTop: (target.offset().top)
                }, 1000, "easeInOutExpo");
                return false;
            }
        }
    });


    $('.js-scroll-trigger').click(function() {
        console.log("folle");
        $('.navbar-collapse').collapse('hide');
    });

    // Activate scrollspy to add active class to navbar items on scroll
    $('body').scrollspy({
        target: '#sideNav'
    });



})(jQuery); // End of use strict
$(document).ready(function() {
    //init selectpicker
    $('.selectpicker').selectpicker({
        dropupAuto: false
    });

    //show tooltip
    $('[data-toggle="tooltip"]').tooltip({
        placement: "right",
        offset: "0, 5"
    });
    // Closes responsive menu when a scroll trigger link is clicked
    $('.js-scroll-trigger').on("click touchstart", function() {
        $('.navbar-collapse').collapse('hide');
    });

    // Text typewrite animation is now handled by the About component in React
})